import { useEffect } from 'react';
import useTournaments from '~/client/features/Tournaments/hooks/useTournaments/useTournaments';
import useAgentData from '~/client/hooks/useAgentData';
import useCurrentUser from '~/client/hooks/user/useCurrentUser';
import useIsLoggedIn from '~/client/hooks/user/useIsLoggedIn';
import useSite from '~/client/hooks/useSite';
import useAccountPopoverStore from '~/client/store/useAccountPopoverStore';
import useAppContext from '~/shared/context/AppContext/useAppContext';
import useGameContext from '../../context/Game/useGameContext';
import BannerView from '@/server/components/Game/TournamentBanner/BannerView';

const TournamentBannerAdapter = () => {
  const { isMobile } = useAgentData();
  const isLoggedIn = useIsLoggedIn();
  const { walletCurrency } = useCurrentUser();
  const { site } = useSite();
  const { translations: allTranslations } = useAppContext();
  const { showPopover } = useAccountPopoverStore();
  const { game } = useGameContext();
  const { tournaments: currentTournaments } = useTournaments({
    status: 'current',
    gameId: game?.id,
  });

  useEffect(() => {
    window.addEventListener('showLoginPopover', showLoginPopover);
    return () => {
      window.removeEventListener('showLoginPopover', showLoginPopover);
    };
  });

  const showLoginPopover = () => {
    showPopover('login');
  };

  const leaderboardTypes = [
    'Total-bets-sum',
    'Total-bets-count',
    'Highest-win',
    'Highest-win-multiplier',
  ];
  const tournamentTypeTranslations = leaderboardTypes.reduce(
    (acc, curr) => [
      ...acc,
      `game-leaderboard.${curr.toLowerCase()}`,
      `tournaments.tooltip_desc_${curr}`,
    ],
    [] as string[],
  );
  const timerBoxTypes = ['days', 'hours', 'minutes', 'seconds'];
  const timerBoxTranslations = timerBoxTypes.reduce(
    (acc, type) => [...acc, `timeleft.${type}`],
    [] as string[],
  );

  const translationKeys = [
    'general.active',
    'game-leaderboard.coming-soon',
    'game-leaderboards.winner',
    'gameleaderboard.past',
    'game-leaderboard.tournament-type',
    'game-leaderboard.prize-pool',
    'general.button.participating',
    'general.promotion.optin',
    'game-leaderboard.claim-prize',
    'gameleaderboard.past',
    'profile.login',
    'general.congratulations',
    'game-leaderboard.claim-prize',
    'game-leaderboards.leaderboard',
    'general.read_more',
    'tournaments.opt-in-successful',
    'rewards.new_reward_added',
    'general.success',
    ...timerBoxTranslations,
    ...tournamentTypeTranslations,
  ];

  const translations = translationKeys.reduce(
    (acc, key) => ({ ...acc, [key]: allTranslations[key] ?? key }),
    {} as Record<string, string>,
  );

  const tournaments = currentTournaments?.map((tournament) => tournament.node);

  if (!tournaments) {
    return null;
  }

  return (
    <BannerView
      tournaments={tournaments}
      translations={translations}
      isMobile={isMobile}
      isLoggedIn={isLoggedIn}
      walletCurrency={walletCurrency ?? ''}
      site={site}
    />
  );
};

export default TournamentBannerAdapter;
